module.exports = __webpack_public_path__ + "static/media/EBGaramond-Regular.d6989885.ttf";